import { connect } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import SliderPanel from '../../../../../components/Editor/EditPanel/SpreadBackgroundPanel/SliderPanel';
import { getGeneralBgData, getSpreadBgData, BackgroundData } from '../../../selectors';
import { BackgroundMediaType, BackgroundSliderData } from '../../../reducer';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			pagesController: { spreads, currentSpreadIndex },
			spreadBackground: { pagesData },
		},
	} = state;
	const spread = spreads[currentSpreadIndex];
	const backgroundData = getSpreadBgData(state, spread) || getGeneralBgData(state) as BackgroundData;
	const { currentMedia, defaultMedia } = backgroundData;
	const { slides } = currentMedia && currentMedia.type === BackgroundMediaType.SLIDER && 'slides' in currentMedia
		? currentMedia
		: (defaultMedia as BackgroundSliderData);
	const page = spread[0];
	const id = `bg-slider-${page}`;
	const importingSlides = pagesData[page] && pagesData[page].importingSlides || [];
	const deps = pagesData[page] && pagesData[page].deps || [];

	return {
		spread,
		page,
		id,
		idInConfigs: id,
		slides,
		importingSlides,
		deps,
		bgMediaData: currentMedia,
		isGeneralBgData: !getSpreadBgData(state, spread) && !!getGeneralBgData(state),
		hasCustomBgMediaData: !!defaultMedia,
	};
};

export default connect(mapStateToProps)(SliderPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/SpreadBackgroundPanel/SliderPanel/index.tsx